import React, { PureComponent, ReactNode } from 'react'
import { connectRedux } from '../../helpers/connectRedux'
import { RouteComponentProps, withRouter } from '../../helpers/withRouter'
import { Page } from '../../components'
import LanguageSelector from '../../containers/LanguageSelector'
import NewPasswordRequiredForm from '../../containers/NewPasswordRequiredForm'
import { appsLogosSelected, appsStyleSelected } from '../../helpers/app'
import { images } from '../../images'
import { urls } from '../../routing'
import { LiteralsService } from '../../services'
import { IStoreState } from '../../store/states'
import StyledArticle from './styles'

interface IProps extends RouteComponentProps {
  language: string
  embedded?: boolean
}

// The form itself lives in NewPasswordRequiredForm, shared with the prompt shown to guests.
class NewPasswordRequired extends PureComponent<IProps> {
  public render(): ReactNode {
    if (this.props.embedded) return this.card

    return (
      <Page className={ appsStyleSelected?.style }>
        <StyledArticle>
          <div className="language-selector">
            <LanguageSelector />
          </div>
          { this.card }
        </StyledArticle>
      </Page>
    )
  }

  private get card(): ReactNode {
    return (
      <form onSubmit={ e => e.preventDefault() }>
        <img src={ images['goBack'] } className="backButton" onClick={ this.handleGoBack } alt="" />
        <header>
          <img  className={ appsLogosSelected?.classRounded }
                src={ appsLogosSelected?.logoRounded }
                alt={ appsLogosSelected?.alt } />
          <h2>{ LiteralsService.get('newPassword', true) }</h2>
        </header>
        <NewPasswordRequiredForm />
      </form>
    )
  }

  private handleGoBack = (): void => {
    this.props.history.push(urls.signIn)
  }
}

// Redraws the literals when the language selector changes the language.
const mapStateToProps = ({ configuration }: IStoreState) => ({
  language: configuration.language
})

export default withRouter(connectRedux(mapStateToProps, NewPasswordRequired))
